import { useMutation } from "@tanstack/react-query";
import { api } from "../api";
import type { SubmitFeedbackPayload } from "../../components/feedback/feedback.types";

export function useFeedback() {
  return useMutation({
    mutationFn: (payload: SubmitFeedbackPayload) => api.submitFeedback(payload),
  });
}
